import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['user']),
  getMessageConfirmation () {
    return {
      cancel: 'Cancelar',
      label: 'Remover',
      title: 'Confirmar Remoção',
      message: `Deseja remover a lista <b>${this.currentEntity.name}</b>?`
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/guest/resources/computed.js